<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Vendas do dia {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          <div class="row">
            <p class="bg-warning btn-round text-white col-md-12" id="error_data" style="display:none">A data selecionada não é uma data valida</p>
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_inicio)" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_fim)" v-model="data_fim">
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>


          <div class="mb-3">
            <div v-for="venda of vendas" class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-6">
                <strong>{{ venda.cliente_object ? venda.cliente_object.nome_razao : ''}}</strong>
                <br>
                <span style="color: #888; font-size: 10px;">{{ venda.data | moment("DD/MM/YYYY") }} {{ venda.hora }}</span>
              </div>
              <div class="col-6">
                V. Receb: {{ venda.valor_recebido | currencyBrl(false) }}
                <br>
                Desc. {{ venda.desconto | currencyBrl(false)}}
                <br>
                {{ venda.forma_pagamento_object ? venda.forma_pagamento_object.descricao : 'COMPOSTO' }}
                <br>
                <button class="btn btn-sm btn-info px-2 py-1" @click="openImpostos(venda)" style="font-size: 10px"><i class="fa fa-info"></i></button>
              </div>
            </div>

            <div class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-6">
                <strong>Total Desconto:</strong>
                <br>
                <strong>Total:</strong>
              </div>
              <div class="col-6">
                {{ total_desconto | currencyBrl(true) }}
                <br>
                {{ total_valor | currencyBrl(true) }}
              </div>
            </div>
          </div>
          <div class="col-md-12" align="right">
            <a :href="notasHref" target="_blank" class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile  btn-primary">Exportar PDF</a>
            <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile  btn-primary" @click="exportaExcel">Exportar Excel</button>
          </div>
          
          <table class="display responsive nowrap table table-hover table-striped hidden-mobile">
            <thead>
              <tr>
                <th>Cliente</th>
                <th class="text-right">Desconto</th>
                <th class="text-right pr-4">Valor Recebido</th>
                <th class="text-center">Forma Pagamento</th>
                <th class="text-center">Data da venda</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="venda of vendas">
                <td>{{ venda.cliente_object ? venda.cliente_object.nome_razao : '' }}</td>
                <td class="text-right">{{ venda.desconto | currencyBrl(true) }}</td>
                <td class="text-right pr-3">{{ venda.valor_recebido | currencyBrl(true) }}</td>
                <td class="text-center">{{ venda.forma_pagamento_object ? venda.forma_pagamento_object.descricao : 'COMPOSTO' }}</td>
                <td class="text-center">{{ venda.data | moment("DD/MM/YY") }} {{ venda.hora }}</td>
                <td class="text-right">
                  <button class="btn btn-sm btn-info px-2 py-1" @click="openImpostos(venda)" style="font-size: 10px"><i class="fa fa-info"></i></button>
                </td>
              </tr>
              <tr v-if="!vendas || !vendas.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                <td class="text-right">{{total_desconto | currencyBrl(true)}}</td>
                <td class="text-right">{{total_valor | currencyBrl(true)  }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>              
            </tfoot>
          </table>

          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import jQuery from 'jquery'
  import {
    Card,
    AnimatedNumber,
    Progress as NProgress,
    LineChart
  } from 'src/components'
import { setInterval } from 'timers';
import {Table, TableColumn} from 'element-ui'
import HeaderChart from '../Dashboard/HeaderChart'
import moment from 'moment'
import GlobalFunctions from '../../../globalFunctions.js'
import VendaService from '@/services/VendaService.js'

export default {
    components: {
      Card,
      AnimatedNumber,
      LineChart,
      NProgress,
      HeaderChart,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      moment
    },
    data() {
      return {
        notasHref: '',
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(),
        chartData: [100, 150, 100, 190, 130, 90, 150, 160, 120, 140, 190, 95],
        chartLabels: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'],
        total_valor:0,
        total_desconto:0,
        vendas: [],
        total: 0,
        data_invalida:null,
        from: 0,
        to: 0,
        current_page: 1,
        pageCount: 0,
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadVendas()
      },
      verificaData(data) {
        let data_formatada = new Date(data);
        if(data_formatada == 'Invalid Date'){
          jQuery('#error_data').show();
        }else{
          jQuery('#error_data').hide();
        }
      },

      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadVendas();
      },
      loadVendas() {
        let loader = this.$loading.show();

        VendaService.load(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}`).then(res => {
          this.pageCount = res.data[0].last_page;
          delete res.data[0].totais;
          this.vendas = res.data[0].data;
          this.from = res.data[0].from;
          this.to = res.data[0].to;
          this.total = res.data[0].total;
          this.total_valor = res.data[1].valor;
          this.total_desconto = res.data[1].desconto;
          
          loader.hide()
        }).catch(err => {
          loader.hide()
        })
        this.reloadNotasHref()
      },

      getUnidade(unidade) {
        let unidades = [  
          "UN",
          "CT",
          "CX",
          "DZ",
          "GZ",
          "PA",
          "PC",
          "PR",
          "PT",
          "RL",
          "KG",
          "G",
          "SC60",
          "L",
          "M3",
          "M2",
          "CM2",
          "M",
          "CM",
          "X"
        ]

        console.log(unidades[unidade])
        return unidades[unidade];
      },
      getLinkWithToken(link) {
        return link + "?token=" + this.token
      },
      exportaExcel(){
          VendaService.geraRelatorioDataExcel("?data_fim="+this.data_fim+"&data_inicio="+this.data_inicio).then(pdf =>{
            let data = pdf.data;            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            let name = "Relatório Por Data.xls";
            // url = window.URL.createObjectURL(data);
            a.href = "data:application/vnd.ms-excel;base64,"+data;
            a.target= "_blank";
            a.download = name;
            console.log(data)
            a.click();
          })
      },
      reloadNotasHref(){
        let stores = JSON.parse(localStorage.getItem('stores'));
        let loja = stores.find(element => element.idi == localStorage.getItem('current_idi'));
        let url = process.env.VUE_APP_API_URL + 'relatorioDataPDF'
        let params = "?token=" + localStorage.getItem("token") + "&" + "data_fim=" +this.data_fim+"&data_inicio="+this.data_inicio+"&cnpj="+loja.cnpj+"&razao_social="+ encodeURIComponent(loja.razao_social) +"&modelo="+this.modelo+"&status="+this.status+"&data_sinc="+this.data_sinc;

        this.notasHref = url + params
      },
      openImpostos(venda) {
        let html = '';

        html += "<h4 class='mb-1' style='font-size: 16px;'><strong>Informação da venda</strong></h4>";
        // html += "<h4 class='mb-4 mt-0' style='font-size: 16px;'>Informação da venda</h4>"
        html += "<div class='text-left ml-4 mt-4'><p style='font-weight: normal'><strong>Desconto</strong>: R$ " + this.$options.filters.currencyBrl(venda.desconto) + "</p>";
        html += "<p style='font-weight: normal'><strong>Produtos</strong></p>";

        for(let produto of venda.itens) {
          html += "<p style='font-weight: normal'>" + produto.produto_object.descricao + " Quantidade: " + produto.quantidade + "</p>";
        }

        html += "<p style='font-weight: normal'><strong>Pagamentos</strong></p>"

        for(let pagamento of venda.pagamentos) {
          html += "<p style='font-weight: normal'>" + pagamento.forma_pagamento_object.descricao + " R$: " + this.$options.filters.currencyBrl(pagamento.valor, false) + "</p>"
        }

        html += "</div>"

        this.$swal({
          html: html
        })
      }
    },
    mounted() {
      this.loadVendas()
    }
}
</script>